import React, {Fragment} from 'react';
import {Text, View, StyleSheet, Image } from '@react-pdf/renderer';

// Images 
import Hi from "../../../../assets/Hi_Logo.png";
import HiLite from "../../../../assets/hilite_logo.png";
import HiRender from "../../../../assets/hiRender Logo 1.png";

const borderColor = '#404040'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#404040',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 50,
        fontStyle: 'bold',
        color: 'white'
    },
    logo: {
        height: 40,
        marginLeft: '30px',
    },
});

const InvoiceTableBlankSpace = ({items}) => {
    const images = items.map( (item, i) => {
        // <Image style={styles.logo} src={item.name} key={i}/>
        return item.name;
    })
    // console.log("Lohith:Payment:InvoiceTableBlankSpace : images", images)
    return (
        <Fragment>
            <View style={styles.row}>
                {/* {images} */}
                {items.map( (item, i) => {
                // <Image style={styles.logo} src={item.name} key={i}/>
                    return <Image style={styles.logo} src={item.name == "Hi" ? Hi : item.name == "HiLite" ? HiLite : HiRender} />
                    // return item.name;
                })}
                {/* <Image style={styles.logo} src={Hi} /> */}
                {/* <Image style={styles.logo} src={HiLite} />
                <Image style={styles.logo} src={HiRender} /> */}
            </View>
        </Fragment>
    )
};
  
export default InvoiceTableBlankSpace

